import React from 'react';
import Table from 'react-bootstrap/Table';

import Const from '../../util/Constants';
import Display from '../../util/Display';

import './LeadPreview.css';
import { LeadDesign } from '../model/ModelAddUpdateDesign';
import FieldController from '../../controller/FieldController';

class LeadInformation extends React.Component {

  constructor(props) {
    super(props);
    this.Design = [];
    this.setDesign(props.model.fields, LeadDesign);
    this.state = {
      propertyName: '',
    };
  }

  async componentDidMount() {
    await this.loadPropertyName(this.props.lead);
  }

  async componentDidUpdate(prevProps) {
    if (this.props.lead?.id !== prevProps.lead?.id) {
      await this.loadPropertyName(this.props.lead);
    }
  }
  loadPropertyName = async (lead) => {
    if (!lead?.property) {
      this.setState({ propertyName: '' });
      return;
    }
    try {
      const propertyName = await this.getPropertyName(lead.property);
      this.setState({ propertyName });
    } catch (err) {
      console.error('Error fetching property name:', err);
      this.setState({ propertyName: 'Error loading property' });
    }
  };

  getPropertyName = async (propertyIds) => {
    let val = propertyIds;
    val = val && val !== '~~' ? val.substring(1, val.length - 1).split(Const.Opt) : [''];

    const names = [];
    for (let i = 0; i < val.length; i++) {
      const name = await Display.getPropertyName(parseInt(val[i]));
      if (name) names.push(name);
    }
    return names.join(', ');
  };

  UNSAFE_componentWillReceiveProps(props) {
    if (props.lead && props.lead.id !== this.id) {
      this.Design = [];
      this.setDesign(props.model.fields, LeadDesign);
    }
  }

  setDesign = (fields, Design) => {
    if (!fields) {
      return;
    }
    const MaxOrder = Math.max(...Design.map(item => item.order));
    const AdditionalFields = {
      order: MaxOrder + 1,
      title: 'Additional Information',
      fields: []
    };
    const LastCallAndSiteVisit = {
      order: MaxOrder + 2,
      title: 'Last Call And Site Visit Information',
      fields: ['last_call_date', 'last_call_feedback', 'last_call_comment', 'next_call_date', 'last_meeting_date', 'last_meeting_feedback', 'last_meeting_comment', 'next_meeting_date',]
    };
    let ModuleFields = Object.keys(fields);
    for (let i in ModuleFields) {
      const item = Design.find(innerDesign =>
        innerDesign.fields.find(innerField => innerField === ModuleFields[i]));
      if (!item) {
        if (!LastCallAndSiteVisit.fields.includes(ModuleFields[i]))
          AdditionalFields.fields.push(ModuleFields[i]);
      }
    }
    this.Design = [...Design.sort((l, r) => l.order - r.order), AdditionalFields, LastCallAndSiteVisit];
    const col = 3;
    for (let i = 0; i < this.Design.length; i++) {
      const designFields = [];
      let counterCol = 0;
      for (let j = 0; j < this.Design[i].fields.length; j++, counterCol++) {
        if (counterCol == col) {
          counterCol = 0;
        }
        if (counterCol == 0) {
          designFields.push([]);
        }
        this.props.model.fields[this.Design[i].fields[j]] && this.props.model.fields[this.Design[i].fields[j]].visible && designFields[designFields.length - 1].push(this.Design[i].fields[j]);
      }
      this.Design[i]['designFields'] = designFields;
    }
  };

  render() { 
    return this.Design.map((item, iIndex) =>
      <div className="formhead" key={`${iIndex + 1}_lead_info`}>
        <h2>{item.title}</h2>
        <div className="row">
          <div className="col-md-4">
            <Table striped bordered hover>
              <tbody>
                {
                  item.designFields.map((arrayFeild, jIndex) =>
                    arrayFeild[0] ?
                      <tr key={`${iIndex + 1}_${jIndex + 1}_lead_info`}>
                        <th key={`${iIndex + 1}_${jIndex + 1}_1`}>
                          {this.props.model.fields[arrayFeild[0]].label_name}
                        </th>
                        <td key={`${iIndex + 1}_${jIndex + 1}_2`}>
                          {arrayFeild[0] == 'property' ? (this.state.propertyName || '-') : Display.FieldValue(this.props.lead, arrayFeild[0], this.props.model.fields)}
                        </td>
                      </tr>
                      : null
                  )
                }
              </tbody>
            </Table>
          </div>

          <div className="col-md-4">
            <Table striped bordered hover>
              <tbody>
                {
                  item.designFields.map((arrayFeild, jIndex) =>
                    arrayFeild[1] ?
                      <tr key={`${iIndex + 1}_${jIndex + 1}_lead_info`}>
                        <th key={`${iIndex + 1}_${jIndex + 1}_1`}>
                          {this.props.model.fields[arrayFeild[1]].label_name}
                        </th>
                        <td key={`${iIndex + 1}_${jIndex + 1}_2`}>
                          {arrayFeild[1] == 'property' ? (this.state.propertyName || '-') : Display.FieldValue(this.props.lead, arrayFeild[1], this.props.model.fields)}
                        </td>
                      </tr>
                      : null
                  )
                }
              </tbody>
            </Table>
          </div>

          <div className="col-md-4">
            <Table striped bordered hover>
              <tbody>
                {
                  item.designFields.map((arrayFeild, jIndex) =>
                    arrayFeild[2] ?
                      <tr key={`${iIndex + 1}_${jIndex + 1}_lead_info`}>
                        <th key={`${iIndex + 1}_${jIndex + 1}_1`}>
                          {this.props.model.fields[arrayFeild[2]].label_name}
                        </th>
                        <td key={`${iIndex + 1}_${jIndex + 1}_2`}>
                          {arrayFeild[2] == 'property' ? (this.state.propertyName || '-') : Display.FieldValue(this.props.lead, arrayFeild[2], this.props.model.fields)}
                        </td>
                      </tr>
                      : null
                  )
                }
              </tbody>
            </Table>
          </div>

          <div className="col-md-4">
            <Table striped bordered hover>
              <tbody>
                {
                  item.designFields.map((arrayFeild, jIndex) =>
                    arrayFeild[3] ?
                      <tr key={`${iIndex + 1}_${jIndex + 1}_lead_info`}>
                        <th key={`${iIndex + 1}_${jIndex + 1}_1`}>
                          {this.props.model.fields[arrayFeild[3]].label_name}
                        </th>
                        <td key={`${iIndex + 1}_${jIndex + 1}_2`}>
                          {arrayFeild[3] == 'property' ? (this.state.propertyName || '-') : Display.FieldValue(this.props.lead, arrayFeild[3], this.props.model.fields)}
                        </td>
                      </tr>
                      : null
                  )
                }
              </tbody>
            </Table>
          </div>
        </div>
      </div >
    );
  }
}

export default LeadInformation;